import en from './en.json'
import it from './it.json'

export const profileTranslations = {
	en,
	it
} as const
